








import {
  Vue,
  Component,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";


@Component ({
  components: {
    GenericLoadingSpinner
  }
})
export default class LoadingSpinnerView extends Vue {

}
